import { Guid } from "guid-typescript";
import { ITemplate } from "interfaces";

export enum DrawerType {
  NONE = "none",
  TEMPLATE_RULE = "templateRule",
  SECTION_RULES = "sectionRules",
  NEW_REPEATING_ADAPTER = "newRepeatingAdapter",
  RICH_TEXT_EDITOR = "richTextEditor",
  XML_EDITOR = "xmlEditor",
  SMS_EDITOR = "smsEditor",
}

export const DEFAULT_DRAWER_STATE = {
  title: "",
  visible: false,
  type: DrawerType.NONE,
  size: "1000px",
  content: "",
};

export const DATE_FORMAT_FOR_SERVER = `YYYY-MM-DD HH:mm:ss`;

export const DEFAULT_PAGE_MARGINS = {
  top: 20,
  bottom: 20,
  left: 20,
  right: 20,
};

export enum RulePrefix {
  DEFAULT = "input1.",
  NUMERIC = "numeric.",
}

export const DEFAULT_RULE = `${RulePrefix.DEFAULT}Default`;

export const SECTIONS_CASE = [
  {
    name: "Empty",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:300px;height:100px;transform:translate(0,0);z-index:0;font-size:14;font-family: &quot;Source Sans Pro&quot;, sans-serif"><p><span>&nbsp;<br></span></p></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "Debtor Address",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:319px;height:150px;transform:translate(0,0)"><table cellspacing="0" cellpadding="0" border="0"><tbody style="border-width:0"><tr><td colspan="3" style="font-size:7px;font-family:&#39;width:96mm;vertical-align:top;height:11mm" align="left"><p style="vertical-align:top"><span style="color:#000;font-family:Arial">Returadresse:<params>BOtherName</params>,</span><span style="font-family:Arial"><params>BAddress1</params>,<params>BPostalCode</params><params>BPostalPlace</params></span></p></td></tr></tbody></table><table border="0" cellpadding="0" cellspacing="0" width="330"><tr><td><span style="font-family:Arial;font-size:12px"><params>EABarcode</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DAddressName</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DAddress1</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DAddress2</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DZipCode</params><params>DZipName</params></span></td></tr></table></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 319,
    height: 150,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "Creditor Address",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:319px;height:110px;transform:translate(0,0)"><table border="0" cellpadding="0" cellspacing="0" width="330"><tr><td><span style="font-family:Arial;font-size:12px"><params>CRName</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRAddr1</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRAddr2</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRAddr3</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRCountryName</params></span></td></tr></table></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 323.6,
    height: 80,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "Claim Details",
    width: 300,
    height: 216.33,
    tokenWarningFlag: 1,
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div height="auto" style="position: absolute; left: 433px; top: 326px; overflow: visible; width: 300px; height: 162px; transform: translate(0px);"><table style="color: rgb(0, 0, 0); background-color: rgb(255, 249, 196); border: 1px solid rgb(255, 213, 79); font-size: 12px;" width="300" cellspacing="0" cellpadding="0" border="0" align="center"><tbody><tr><td height="5">&nbsp;</td></tr><tr><td valign="top"><table style="color: rgb(0, 0, 0); font-size: 14px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" border="0" cellpadding="0" cellspacing="0" width="300"><tbody><tr><td width="10">&nbsp;</td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="100"><span style="font-size: 13px;">Sak </span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="20" align="right"><span style="font-size: 13px;">:</span></td><td style="font-size: 18px; font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;"><params contenteditable="false" suppresscontenteditablewarning="true">CCaseNo</params></span></td><td width="10"><span style="font-size: 13px;">&nbsp;</span></td></tr><tr><td width="10">&nbsp;</td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="100"><span style="font-size: 13px;">Kreditor</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="20" align="right"><span style="font-size: 13px;">:</span></td><td style="font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;"><params contenteditable="false" suppresscontenteditablewarning="true">CreditorInfo</params></span></td><td width="10"><span style="font-size: 13px;">&nbsp;</span></td></tr><tr><td width="10">&nbsp;</td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="100"><span style="font-size: 13px;">Forfall</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="20" align="right"><span style="font-size: 13px;">:</span></td><td style="font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;"><params contenteditable="false" suppresscontenteditablewarning="true">LDueDate</params></span></td><td width="10"><span style="font-size: 13px;">&nbsp;</span></td></tr><tr><td width="10"><span style="font-size: 13px;">&nbsp;</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);"><span style="font-size: 13px;">Konto nr.</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" align="right"><span style="font-size: 13px;">:</span></td><td style="font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;"><params contenteditable="false" suppresscontenteditablewarning="true">BureauClientAccount</params></span></td><td width="10">&nbsp;</td></tr><tr><td width="10">&nbsp;</td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="100"><span style="font-size: 13px;">KID</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="20" align="right"><span style="font-size: 13px;">:</span></td><td style="font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;"><params contenteditable="false" suppresscontenteditablewarning="true">CKID</params></span></td><td width="10">&nbsp;</td></tr><tr><td width="10">&nbsp;</td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="100"><span style="font-size: 13px;">Beløp å betale</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="20" align="right"><span style="font-size: 13px;">:</span></td><td style="font-size: 16px; font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;"><params contenteditable="false" suppresscontenteditablewarning="true">CBalance</params></span></td><td width="10"><span style="font-size: 13px;">&nbsp;</span></td></tr><tr><td width="10"><span style="font-size: 13px;">&nbsp;</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="100"><span style="font-size: 13px;">Saksbehandler&nbsp;</span></td><td style="font-weight: 400; color: rgb(0, 0, 0);" width="20" align="right"><span style="font-size: 13px;">&nbsp;:</span></td><td style="font-size: 16px; font-weight: 600; color: rgb(0, 0, 0);" width="180" align="right"><span style="font-size: 13px;">&nbsp;<params contenteditable="false" suppresscontenteditablewarning="true">CAHandler</params></span></td><td width="10">&nbsp;</td></tr><tr><td height="5"> &nbsp;</td></tr></tbody></table></td></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
  },
  {
    name: "Bureau Details",
    width: 300,
    height: 140,
    tokenWarningFlag: 1,
    reusable: true,
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position: absolute;overflow: visible; width: 300px; height: 140px; transform: translate(0px, 0px);"><table style="font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" cellspacing="0" cellpadding="0" border="0" width="300">    <tbody>        <tr>            <td align="right"> <params>Logo</params></td>        </tr>        <tr>            <td style="color: #555555; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right"> <params>BAddress1</params></td>        </tr>        <tr>            <td style="color: #555555; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right"><params>BOrgNo</params> (Foretaksregisteret)</td>        </tr>        <tr>            <td style="color: #555555;  text-decoration: none; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right">            <p style="text-align:right">E-post: <params>BEmail</params></p>            </td>        </tr>        <tr>            <td style="color: #555555;  text-decoration: none; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right">            <p style="text-align:right">Telefon: <params>BPhoneNumber</params></p>            </td>        </tr>        <tr>            <td style="color: #555555;  text-decoration: none; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right">            <p style="text-align:right">Dato : <params>TODAY</params></p>            </td>        </tr>    </tbody></table></div>',
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
  },
  {
    name: "Table",
    tokenWarningFlag: 0,
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:50px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent: "",
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 50,
    reusable: true,
  },
  {
    name: "Repeating Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:80px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse" repeatable="true" id="repeatableTable" repeatingadapterid="0"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">Column 1</td><td style="word-break:break-all;border:1px solid #ccc">Column 2</td><td style="word-break:break-all;border:1px solid #ccc">Column 3</td><td style="word-break:break-all;border:1px solid #ccc">Column 4</td></tr><tr id="repeatingcontent" repeatingadapterid="0"></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent:
          '<tr id="repeatingcontent"><td style="word-break:break-all;border:1px solid #ccc"><span>Param 1</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 2</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 3</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 4</span></td></tr>',
        isRepeating: true,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 80,
    tokenWarningFlag: 0,
    reusable: true,
  },
];
export const SECTIONS_CREDITOR = [
  {
    name: "Empty",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:300px;height:100px;transform:translate(0,0);z-index:0;font-size:14;font-family: &quot;Source Sans Pro&quot;, sans-serif"><p><span>&nbsp;<br></span></p></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "Creditor",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:300px;height:100px;transform:translate(0,0);z-index:0;font-size:14;font-family: &quot;Source Sans Pro&quot;, sans-serif"><p><span>Hei &nbsp;<params>CRName</params><br></span></p></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:50px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent: "",
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 50,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "Repeating Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:80px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse" repeatable="true" id="repeatableTable" repeatingadapterid="0"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">Column 1</td><td style="word-break:break-all;border:1px solid #ccc">Column 2</td><td style="word-break:break-all;border:1px solid #ccc">Column 3</td><td style="word-break:break-all;border:1px solid #ccc">Column 4</td></tr><tr id="repeatingcontent" repeatingadapterid="0"></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent:
          '<tr id="repeatingcontent"><td style="word-break:break-all;border:1px solid #ccc"><span>Param 1</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 2</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 3</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 4</span></td></tr>',
        isRepeating: true,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 80,
    tokenWarningFlag: 0,
    reusable: true,
  },
];

export const SECTIONS_DEBTOR = [
  {
    name: "Empty",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:300px;height:100px;transform:translate(0,0);z-index:0;font-size:14;font-family: &quot;Source Sans Pro&quot;, sans-serif"><p><span>&nbsp;<br></span></p></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "DebtorAddress",
    rules: [
      {
        ruleName: "",
        content:
          '<div height="auto" style="position: absolute; left: 57px; top: 30px; overflow: visible; width: 296px; height: 100px; transform: translate(0px, 0px);"><p><span style="font-family: Calibri; font-size: 14px;"><params contenteditable="false" suppresscontenteditablewarning="true">CFirstName</params><params contenteditable="false" suppresscontenteditablewarning="true">CLastname</params></span><br /><span style="font-family: Calibri; font-size: 14px;"><params contenteditable="false" suppresscontenteditablewarning="true">CAdress1</params><params contenteditable="false" suppresscontenteditablewarning="true">CAdress2</params></span><br /><span style="font-family: Calibri; font-size: 14px;"><params contenteditable="false" suppresscontenteditablewarning="true">CZIP</params><params contenteditable="false" suppresscontenteditablewarning="true">CCity</params></span><br /><span style="font-family: Calibri; font-size: 14px;">&nbsp;</span></p><p>&nbsp;</p></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "BureauInfo",
    rules: [
      {
        ruleName: "",
        content:
          '<div height="auto" style="position: absolute; left: 477px; top: 63px; overflow: visible; width: 312px; height: 181px; transform: translate(0px);"><table style="font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" width="300" border="0" cellpadding="0" cellspacing="0"><tbody><tr><td align="right"><params contenteditable="false" suppresscontenteditablewarning="true">Logo</params></td></tr><tr><td style="color: rgb(85, 85, 85); font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"><params contenteditable="false" suppresscontenteditablewarning="true">BAddress1</params></td></tr><tr><td style="color: rgb(85, 85, 85); font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"><params contenteditable="false" suppresscontenteditablewarning="true">BOrgNo</params>(Foretaksregisteret)</td></tr><tr><td style="color: rgb(85, 85, 85); text-decoration: none; font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"><p style="text-align: right;">E-post:<params contenteditable="false" suppresscontenteditablewarning="true">BEmail</params></p></td></tr><tr><td style="color: rgb(85, 85, 85); text-decoration: none; font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"><p style="text-align: right;">Telefon:<params contenteditable="false" suppresscontenteditablewarning="true">BPhoneNumber</params></p></td></tr><tr><td style="color: rgb(85, 85, 85); text-decoration: none; font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"><p style="text-align: right;">Dato :<params contenteditable="false" suppresscontenteditablewarning="true">TODAY</params></p></td></tr></tbody></table>&nbsp;</div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "CreditorDebtor",
    rules: [
      {
        ruleName: "",
        content:
          '<div height="auto" style="position: absolute; left: 79px; top: 326px; overflow: visible; width: 691px; height: 108px; transform: translate(0px);"><table style="width: 700px; background-color: rgb(192, 192, 192);" cellpadding="2" cellspacing="2"><tbody><tr><td style="width: 75px; height: 40px;">&nbsp;CID :</td><td style="height: 40px; width: 250px;"><params contenteditable="false" suppresscontenteditablewarning="true">CNumber</params></td><td style="height: 40px; width: 125px;">Debtor Name :</td><td style="height: 40px; width: 250px;"><params contenteditable="false" suppresscontenteditablewarning="true">CLastname</params><params contenteditable="false" suppresscontenteditablewarning="true">CFirstName</params></td></tr><tr><td style="width: 75px; height: 40px;">&nbsp;PID :</td><td style="height: 40px; width: 250px;"><params contenteditable="false" suppresscontenteditablewarning="true">CRNumber</params></td><td style="width: 125px; height: 40px;">Creditor Name :</td><td style="height: 40px; width: 250px;"><params contenteditable="false" suppresscontenteditablewarning="true">CRName</params></td></tr></tbody></table>&nbsp;&nbsp;</div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:50px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent: "",
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 50,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "Repeating Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:80px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse" repeatable="true" id="repeatableTable" repeatingadapterid="0"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">Column 1</td><td style="word-break:break-all;border:1px solid #ccc">Column 2</td><td style="word-break:break-all;border:1px solid #ccc">Column 3</td><td style="word-break:break-all;border:1px solid #ccc">Column 4</td></tr><tr id="repeatingcontent" repeatingadapterid="0"></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent:
          '<tr id="repeatingcontent"><td style="word-break:break-all;border:1px solid #ccc"><span>Param 1</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 2</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 3</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 4</span></td></tr>',
        isRepeating: true,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 80,
    tokenWarningFlag: 0,
    reusable: true,
  },
];

export const SECTIONS_SUBCASE = [
  {
    name: "Empty",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:300px;height:100px;transform:translate(0,0);z-index:0;font-size:14;font-family: &quot;Source Sans Pro&quot;, sans-serif"><p><span>&nbsp;<br></span></p></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 300,
    height: 100,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "Debtor Address",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:319px;height:150px;transform:translate(0,0)"><table cellspacing="0" cellpadding="0" border="0"><tbody style="border-width:0"><tr><td colspan="3" style="font-size:7px;font-family:&#39;width:96mm;vertical-align:top;height:11mm" align="left"><p style="vertical-align:top"><span style="color:#000;font-family:Arial">Returadresse:<params>BOtherName</params>,</span><span style="font-family:Arial"><params>BAddress1</params>,<params>BPostalCode</params><params>BPostalDistrict</params></span></p></td></tr></tbody></table><table border="0" cellpadding="0" cellspacing="0" width="330"><tr><td><span style="font-family:Arial;font-size:12px"><params>EABarcode</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DebtorAddressName</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DebtorAdress1</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DebtorAdress2</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DebtorZIPCode</params><params>DebtorZIPName</params></span></td></tr></table></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 319,
    height: 150,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "Creditor Address",
    rules: [
      {
        ruleName: "",
        content:
          '<div style="position:absolute;overflow:visible;width:319px;height:110px;transform:translate(0,0)"><table border="0" cellpadding="0" cellspacing="0" width="330"><tr><td><span style="font-family:Arial;font-size:12px"><params>CRName</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRAddress1</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRAddress2</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRAddress3</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>CRCountryName</params></span></td></tr></table></div>',
        rule: DEFAULT_RULE,
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 323.6,
    height: 80,
    tokenWarningFlag: 1,
    reusable: true,
  },
  {
    name: "Claim Details",
    width: 300,
    height: 216.33,
    tokenWarningFlag: 1,
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position: absolute;background-color: #fff9c4;border: 1px solid #ffd54f;overflow: visible; width: 301.6px; height: 160px; transform: translate(0px, 0px);"><table style="color: #000000;   font-size: 12px;" width="301.6" cellspacing="0" cellpadding="0" border="0" align="center">    <tbody>        <tr>            <td height="5"></td>        </tr>        <tr>            <td valign="top">            <table style="color: #000; font-size: 14px; font-family: \'Source Sans Pro\', sans-serif;" width="300" cellspacing="0" cellpadding="0" border="0">                <tbody>                    <tr>                        <td width="10"></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">Sak </span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-size:18px; font-weight: 600; color: #000;" align="right" width="180"><span style="font-size:13px"><params>IPrintCaseNo</params></span></td>                        <td width="10"><span style="font-size:13px"></span></td>                    </tr>                    <tr>                        <td width="10"><span style="font-size:13px"></span></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">Faktura nr</span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-size:18px; font-weight: 600; color: #000;" align="right" width="180"><span style="font-size:13px"><params>ITNumber</params></span></td>                        <td width="10"><span style="font-size:13px"></span></td>                    </tr>                    <tr>                        <td width="10"><span style="font-size:13px"></span></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">Kreditor</span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-weight: 600; color: #000;" align="right" width="180"><span style="font-size:13px"><params>CreditorInfo</params></span></td>                        <td width="10"><span style="font-size:13px"></span></td>                    </tr>                    <tr>                        <td width="10"></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">Forfall</span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-weight: 600; color: #000;" align="right" width="180"><params>CADWDate</params></td>                        <td width="10"><span style="font-size:13px"></span></td>                    </tr>                    <tr>                        <td width="10"><span style="font-size:13px"></span></td>                        <td style="font-weight: 400; color: #000;"><span style="font-size:13px">Konto nr.</span></td>                        <td style="font-weight: 400; color: #000;" align="right"><span style="font-size:13px">:</span></td>                        <td style="font-weight: 600; color: #000;" align="right" width="180"><params>BureauClientAccount</params></td>                        <td width="10"></td>                    </tr>                    <tr>                        <td width="10"></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">KID</span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-weight: 600; color: #000;" align="right" width="180"><span style="font-size:13px"><params>IKID</params></span></td>                        <td width="10"></td>                    </tr>                    <tr>                        <td width="10"></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">Beløp å betale</span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-size:16px; font-weight: 600; color: #000;" align="right" width="180"><span style="font-size:13px"><params>IBalance</params></span></td>                        <td width="10"><span style="font-size:13px"></span></td>                    </tr>                    <tr>                        <td width="10"><span style="font-size:13px"></span></td>                        <td style="font-weight: 400; color: #000;" width="100"><span style="font-size:13px">saksbehandler</span></td>                        <td style="font-weight: 400; color: #000;" align="right" width="20"><span style="font-size:13px">:</span></td>                        <td style="font-size:16px; font-weight: 600; color: #000;" align="right" width="180"><span style="font-size:13px"></span><span style="font-size:13px"><params>CAHandler</params></span></td>                        <td width="10"></td>                    </tr>                    <tr>                        <td height="5"> </td>                    </tr>                </tbody>            </table>            </td>        </tr>    </tbody></table></div>',
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
  },
  {
    name: "Bureau Details",
    width: 300,
    height: 140,
    tokenWarningFlag: 1,
    reusable: true,
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position: absolute;overflow: visible; width: 300px; height: 140px; transform: translate(0px, 0px);"><table style="font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" cellspacing="0" cellpadding="0" border="0" width="300">    <tbody>        <tr>            <td align="right"> <params>Logo</params></td>        </tr>        <tr>            <td style="color: #555555; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right"> <params>BAddress1</params></td>        </tr>        <tr>            <td style="color: #555555; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right"><params>BureauOrgNo</params> (Foretaksregisteret)</td>        </tr>        <tr>            <td style="color: #555555;  text-decoration: none; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right">            <p style="text-align:right">E-post: <params>BEmail</params></p>            </td>        </tr>        <tr>            <td style="color: #555555;  text-decoration: none; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right">            <p style="text-align:right">Telefon: <params>BPhoneNumber</params></p>            </td>        </tr>        <tr>            <td style="color: #555555;  text-decoration: none; font-size: 13px; font-family: &#39;Source Sans Pro&#39;, sans-serif" align="right">            <p style="text-align:right">Dato : <params>Today</params></p>            </td>        </tr>    </tbody></table></div>',
        isDefault: true,
        repeatingContent: null,
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
  },
  {
    name: "Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:50px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr><tr><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td><td style="word-break:break-all;border:1px solid #ccc">&nbsp;<br></td></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent: "",
        isRepeating: false,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 50,
    tokenWarningFlag: 0,
    reusable: true,
  },
  {
    name: "Repeating Table",
    rules: [
      {
        ruleName: "",
        rule: DEFAULT_RULE,
        content:
          '<div style="position:absolute;overflow:visible;width:689px;height:80px;transform:translate(0,0);z-index:0;font-size:14;font-family:&quot"><table border="1" style="table-layout:fixed;width:100%;border-collapse:collapse" repeatable="true" id="repeatableTable" repeatingadapterid="0"><tbody><tr><td style="word-break:break-all;border:1px solid #ccc">Column 1</td><td style="word-break:break-all;border:1px solid #ccc">Column 2</td><td style="word-break:break-all;border:1px solid #ccc">Column 3</td><td style="word-break:break-all;border:1px solid #ccc">Column 4</td></tr><tr id="repeatingcontent" repeatingadapterid="0"></tr></tbody></table></div>',
        isDefault: true,
        repeatingContent:
          '<tr id="repeatingcontent"><td style="word-break:break-all;border:1px solid #ccc"><span>Param 1</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 2</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 3</span></td><td style="word-break:break-all;border:1px solid #ccc"><span>Param 4</span></td></tr>',
        isRepeating: true,
        repeatingAdapterId: 0,
      },
    ],
    width: 691,
    height: 80,
    tokenWarningFlag: 0,
    reusable: true,
  },
];

export enum DocumentType {
  ALL = "All",
  PDF = "PDF",
  SMS = "SMS",
  EHF = "EHF",
  EMAIL = "Email",
}

export const PageProperties = {
  PDF: {
    width: "8.5in",
    height: "11.69in",
    type: DocumentType.PDF,
    widthPx: 800,
  },
  SMS: { width: "8.5in", height: "5in", type: DocumentType.SMS, widthPx: 800 },
  EHF: {
    width: "8.5in",
    height: "auto",
    type: DocumentType.EHF,
    widthPx: 800,
  },
  EMAIL: {
    width: "854px",
    height: "1418px",
    type: DocumentType.EMAIL,
    widthPx: 854,
  },
};

export const PICKER_COLORS = [
  "#FFFFFF",
  "#585f75",
  "#585555",
  "#fff9c4",
  "#c5545c",
  "#a94442",
  "#d9edf7",
  "#f2dede",
  "#ff8a65",
  "#000000",
];

export const DEFAULT_TEMPLATE_DETAILS: ITemplate = {
  templateId: 0,
  groupId: 1,
  categoryId: 1,
  templateName: "Untitled Template",
  description: "Untitled Template Description",
  isActive: false,
  lastUpdatedDate: "0001-01-01T00:00:00",
  createdDate: "0001-01-01T00:00:00",
  outPutFormat: DocumentType.PDF,
  groupName: "",
  categoryName: "",
  previewImage: null,
  mainAdapterId: 1,
  activityNumbers: null,
  isMessageTemplateAdded: false,
  templateContent: {
    id: "0",
    batchNo: Guid.create().toString(),
    pages: [
      {
        bgImage: "",
        sections: [
          {
            name: "DebtorDetails",
            width: 319,
            height: 150,
            locked: false,
            rules: [
              {
                ruleName: null,
                rule: "input1.Default",
                content:
                  '<div style="position:absolute;left:76px;top:66px;overflow:visible;width:330px;height:150px;transform:translate(0,0)" height="auto"><table border="0" cellpadding="0" cellspacing="0"><tbody style="border-width:0"><tr><td style="font-size:7px;width:96mm;vertical-align:top;height:11mm" align="left" colspan="3"><p style="vertical-align:top"><span style="color:#000;font-family:Arial">Returadresse:<params>BOtherName</params>,</span><span style="font-family:Arial"><params>BAddress1</params>,<params>BPostalCode</params><params>BPostalDistrict</params></span></p></td></tr></tbody></table><table width="330" cellspacing="0" cellpadding="0" border="0"><tbody><tr><td><p style="line-height:100%"><span style="font-family:Arial;font-size:12px"><params>EABarcode</params></span></p></td></tr><tr><td><p style="line-height:100%"><span style="font-family:Arial;font-size:12px"><params>DebtorAddressName</params></span></p></td></tr><tr><td><span style="font-family:Arial;font-size:12px;color:#000"><params>DebtorAdress1</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DebtorAdress2</params></span></td></tr><tr><td><span style="font-family:Arial;font-size:12px"><params>DebtorZIPCode</params>&nbsp; &nbsp;</span><span style="color:#000;font-family:Arial;font-size:12px"><params>DebtorZIPName</params></span></td></tr></tbody></table>&nbsp;&nbsp;</div>',
                isDefault: true,
                repeatingContent: null,
                isRepeating: false,
                repeatingAdapterId: 0,
              },
            ],
          },
          {
            name: "KIDDetails",
            width: 302,
            height: 238,
            locked: false,
            rules: [
              {
                ruleName: null,
                rule: "input1.Default",
                content:
                  '<div style="position:absolute;background-color:#fff9c4;border:1px solid #ffd54f;left:453.34827041625977px;top:331px;overflow:visible;width:301.6px;height:180px;transform:translate(0,0)"><table align="center" border="0" cellpadding="0" cellspacing="0" width="301.6" style="color:#000;font-size:12px"><tbody><tr><td height="5">&nbsp;</td></tr><tr><td valign="top"><table border="0" cellpadding="0" cellspacing="0" width="300" style="color:#000;font-size:14px;font-family:\'Source Sans Pro\',sans-serif"><tbody><tr><td width="10"></td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">Sak</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-size:18px;font-weight:600;color:#000"><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">IPrintCaseNo</params></span></td><td width="10"><span style="font-size:13px">&nbsp;</span></td></tr><tr><td width="10"><span style="font-size:13px">&nbsp;</span></td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">Faktura nr</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">&nbsp;:</span></td><td width="180" align="right" style="font-size:18px;font-weight:600;color:#000"><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CExCaseNo</params></span></td><td width="10"><span style="font-size:13px">&nbsp;</span></td></tr><tr><td width="10"><span style="font-size:13px">&nbsp;</span></td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">Kreditor</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-weight:600;color:#000"><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CreditorInfo</params></span></td><td width="10"><span style="font-size:13px">&nbsp;</span></td></tr><tr><td width="10"></td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">Forfall</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-weight:600;color:#000"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">IDueDate</params></td><td width="10"><span style="font-size:13px">&nbsp;</span></td></tr><tr><td width="10"><span style="font-size:13px">&nbsp;</span></td><td style="font-weight:400;color:#000"><span style="font-size:13px">Konto nr.</span></td><td align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-weight:600;color:#000"><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">BureauClientAccount</params></span></td><td width="10"></td></tr><tr><td width="10">&nbsp;</td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">KID</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-weight:600;color:#000"><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">IKID</params></span></td><td width="10"></td></tr><tr><td width="10"></td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">Beløp å betale</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-size:16px;font-weight:600;color:#000"><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">IBalance</params></span></td><td width="10"><span style="font-size:13px">&nbsp;</span></td></tr><tr><td width="10"><span style="font-size:13px">&nbsp;</span></td><td width="100" style="font-weight:400;color:#000"><span style="font-size:13px">saksbehandler</span></td><td width="20" align="right" style="font-weight:400;color:#000"><span style="font-size:13px">:</span></td><td width="180" align="right" style="font-size:16px;font-weight:600;color:#000"><span style="font-size:13px">&nbsp;</span><span style="font-size:13px"><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CAHandler</params></span></td></tr></tbody></table></td></tr></tbody></table></div>',
                isDefault: true,
                repeatingContent: null,
                isRepeating: false,
                repeatingAdapterId: 0,
              },
            ],
          },
          {
            name: "Text",
            width: 361,
            height: 340,
            locked: false,
            rules: [
              {
                ruleName: null,
                rule: "input1.Default",
                content:
                  '<div style="position:absolute;left:76px;top:399px;overflow:visible;width:361px;height:340px;transform:translate(0,0);z-index:0"><table cellspacing="2" cellpadding="2" border="0" style="width:341px;overflow:hidden"><tbody><tr><td style="position:relative"><h2 style="margin-right:0;margin-bottom:10px;margin-left:0;padding:0;font-family:Impact;color:#000;font-size:24px">OVERSIKT OVER KRAVET</h2><br><p>Saksnr:<params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CExCaseNo</params></p><p>Kreditor:<params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CRName</params></p><p><span style="font-family:calibri;font-weight:700"><br></span></p><p>Her følger en oversikt over kravet med betalingsinformasjon pr i dag. Se oppstilling til høyre.<br></p><br><p>Med hilsen</p><p><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">BName</params></p><p>ved saksbehandler</p><br><p><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CAHandler</params></p><p><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CAHandlerEmail</params></p><br></td></tr></tbody></table></div>',
                isDefault: true,
                repeatingContent: null,
                isRepeating: false,
                repeatingAdapterId: 0,
              },
            ],
          },
          {
            name: "BueroDetailsBO",
            width: 300,
            height: 140,
            locked: false,
            rules: [
              {
                ruleName: null,
                rule: "input1.Default",
                content:
                  '<div style="position: absolute; left: 449px; top: 66px; overflow: visible; width: 300px; height: 128px; transform: translate(0px, 0px);" height="auto"><table style="font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" width="300" border="0" cellpadding="0" cellspacing="0"><tbody><tr><td align="right"> <params>Logo</params></td></tr><tr><td style="color: rgb(85, 85, 85); font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"> <params>BAddress1</params></td></tr><tr><td style="color: rgb(85, 85, 85); font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right"><params>BureauOrgNo</params> (Foretaksregisteret)</td></tr><tr><td style="color: rgb(85, 85, 85); text-decoration: none; font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right">            <p style="text-align: right;">E-post: <params>BEmail</params></p>            </td></tr><tr><td style="color: rgb(85, 85, 85); text-decoration: none; font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right">            <p style="text-align: right;">Telefon: <params>BPhoneNumber</params></p>            </td></tr><tr><td style="color: rgb(85, 85, 85); text-decoration: none; font-size: 13px; font-family: &quot;Source Sans Pro&quot;, sans-serif;" align="right">            <p style="text-align: right;">Dato : <params>Today</params></p>            </td></tr></tbody></table>&nbsp;</div>',
                isDefault: true,
                repeatingContent: null,
                isRepeating: false,
                repeatingAdapterId: 0,
              },
            ],
          },
        ],
      },
    ],
    rootElement: "html",
    headElement: "",
    backImage: false,
    category: "Documents",
    content: true,
    templateId: 0,
    templateName: "Untitled Template",
    group: "",
    isMarginApplied: false,
    previewImage: null,
    output: {
      format: DocumentType.PDF,
    },
    adapter: {
      mainAdapterId: 1,
      repeatingAdapters: [],
    },
    margin: DEFAULT_PAGE_MARGINS,
    versionNo: -1,
  },
};

export const DEFAULT_SMS_TEMPLATE_DETAILS: ITemplate = {
  templateId: 0,
  groupId: 1,
  categoryId: 1,
  templateName: "Untitled Template",
  description: "Untitled Template Description",
  isActive: false,
  lastUpdatedDate: "0001-01-01T00:00:00",
  createdDate: "0001-01-01T00:00:00",
  outPutFormat: DocumentType.SMS,
  groupName: "",
  categoryName: "",
  previewImage: null,
  mainAdapterId: 1,
  activityNumbers: null,
  isMessageTemplateAdded: false,
  templateContent: {
    id: "0",
    batchNo: Guid.create().toString(),
    pages: [
      {
        bgImage: "",
        sections: [
          {
            name: "Text",
            width: 319,
            height: 150,
            locked: false,
            rules: [
              {
                ruleName: null,
                rule: "input1.Default",
                content:
                  '<div style="position: absolute; left: 32px; top: 33px; overflow: visible; width: 374px; height: 140px; transform: translate(0px, 0px);" height="auto"></div>',
                isDefault: true,
                repeatingContent: null,
                isRepeating: false,
                repeatingAdapterId: 0,
              },
            ],
          },
        ],
      },
    ],
    rootElement: "html",
    headElement: "",
    backImage: false,
    category: "Documents",
    content: true,
    templateId: 0,
    templateName: "Untitled Template",
    group: "",
    isMarginApplied: false,
    previewImage: null,
    output: {
      format: DocumentType.SMS,
    },
    adapter: {
      mainAdapterId: 1,
      repeatingAdapters: [],
    },
    margin: DEFAULT_PAGE_MARGINS,
    versionNo: -1,
  },
};

export const DEFAULT_EMAIL_TEMPLATE_DETAILS: ITemplate = {
  templateId: 0,
  groupId: 1,
  categoryId: 1,
  templateName: "Untitled Template",
  description: "Untitled Template Description",
  isActive: false,
  lastUpdatedDate: "0001-01-01T00:00:00",
  createdDate: "0001-01-01T00:00:00",
  outPutFormat: DocumentType.EMAIL,
  groupName: "",
  categoryName: "",
  previewImage: null,
  mainAdapterId: 1,
  activityNumbers: null,
  isMessageTemplateAdded: false,
  templateContent: {
    id: "0",
    batchNo: Guid.create().toString(),
    pages: [
      {
        bgImage: "",
        sections: [
          {
            name: "Empty",
            width: 854,
            height: 1158,
            locked: false,
            rules: [
              {
                ruleName: "",
                rule: "input1.Default",
                content:
                  '<div height=auto style=position:absolute;left:0;top:0;overflow:visible;width:100%;transform:translate(0,0);z-index:0;font-size:14px><table border=0 cellpadding=0 cellspacing=0 style=width:100%;background:#f4f4f4;border-collapse:collapse width=100%><tr><td style=width:100%;padding:0;background-size:cover valign=top width=100%><div align=center><table border=0 cellpadding=0 cellspacing=0 style=width:100%;border-collapse:collapse class=layout-space width=100%><tr><td style="padding:.5in 0"valign=top class=sm_padding_none><div align=center><table border=0 cellpadding=0 cellspacing=0 style=width:640px;border-collapse:collapse;background-size:cover class=sm_container><tr><td style=background:#fff;padding:0 valign=top><div align=center><table border=0 cellpadding=0 cellspacing=0 style=width:100%;border-collapse:collapse;background-size:cover width=100%><tr><td style=padding:0 valign=top><table border=0 cellpadding=0 cellspacing=0 style=width:100%;border-collapse:collapse width=100%><tr><td style=width:100%;padding:0 valign=top align=center width=100%><table border=0 cellpadding=0 cellspacing=0 style=width:100%;border-collapse:collapse class=table-inner width=100%><tr><td style="padding:20pt .5in 10pt"valign=top class=sm_padding_x><p style=text-align:center;margin:0 align=center><br><p style=text-align:center;margin:0 align=center><br><p style=text-align:center;margin:0 align=center><params contenteditable=false suppresscontenteditablewarning=true>Logo</params><tr><td style="padding:5pt .5in"valign=top class=sm_padding_x align=center><div><span style=font-weight:700><span style=font-size:24px>PURRING RESTBELØP</span></span></div><tr><td style="padding:0 .5in 20pt"valign=top class=sm_padding_x align=center><div><p style=font-weight:700><span style=font-weight:700>Dato : </span><params contenteditable=false suppresscontenteditablewarning=true>Today</params></div><tr><td style="padding:0 .5in 10pt"valign=top class=sm_padding_x align=center><div><br></div><tr><td style="padding:0 .5in 10pt"valign=top class=sm_padding_x align=center><div><p style=font-weight:700> <span style=font-weight:700>Saksnr : </span><params contenteditable=false suppresscontenteditablewarning=true>CExCaseNo</params><span style=font-weight:700> Kreditor : </span><params contenteditable=false suppresscontenteditablewarning=true>CRName</params></div><p><br><tr><td style="padding:0 .5in 25pt"valign=top class=sm_padding_x align=center><div><p>Vi har mottatt og registrert betaling fra deg. Vi ber deg med dette om å gjøre opp resterende beløp innen forfall, da det ellers vil påløpe ytterligere omkostninger.<p><br><p>Vær snill å oppgi KID og kontonummer som spesifisert i dette dokumentet.<p><br><p>Med hilsen<br><params contenteditable=false suppresscontenteditablewarning=true>BName</params><br>ved saksbehandler<p><br><p><params contenteditable=false suppresscontenteditablewarning=true>CAHandler</params><p><params contenteditable=false suppresscontenteditablewarning=true>CAHandlerEmail</params></div><tr><td style="background:#fff9d5;padding:15pt .5in"valign=top class=sm_padding_x><table border=0 cellpadding=0 cellspacing=0 style=width:100%;border-collapse:collapse;table-layout:fixed class=sm_container width=100%><tr><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Sak</span><p><span style=font-size:16px>1015033</span><br><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Faktura nr.</span><p><span style=font-size:16px>56845875</span><br><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Kreditor</span><p><span style=font-size:16px>Ola Nordmann</span><br><tr><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Forfall</span><p><span style=font-size:16px>14.03.2024</span><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Konto nr.</span><p><span style=font-size:16px>1123 58 11235</span><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>KID</span><p><span style=font-size:16px>110101503372321</span><tr><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Beløp å betale</span><p><span style=font-size:16px>1000.00</span><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"><p><span style=font-weight:700>Saksbehandler</span><p><span style=font-size:16px>Jhon Doe</span><td style="padding:0 10pt 10pt 0"valign=top class="sm_column sm_text_center"></table><tr><td style="text-align:center;padding:25pt .5in"valign=top class=sm_padding_x align=center><table border=0 cellpadding=0 cellspacing=0 style="width:75%;border-collapse:collapse;margin:0 auto;table-layout:fixed"class=sm_container><tr><td style="text-align:left;padding:0 0 5pt"valign=top>Hovedstol (spesifisert nedenfor)<td style="padding:0 0 5pt"valign=top align=right>1000.00<tr><td style="text-align:left;padding:0 0 5pt"valign=top>Forsinkelsesrente fra 09.12.2023<td style="padding:0 0 5pt"valign=top align=right>0.00<tr><td style="text-align:left;padding:0 0 5pt"valign=top>Purregebyr/Eu Gebyr<td style="padding:0 0 5pt"valign=top align=right>0.00<tr><td style="text-align:left;padding:0 0 5pt"valign=top>Innbetalt<td style="padding:0 0 5pt"valign=top align=right>0.00<tr><td style="text-align:left;padding:0 0 5pt"valign=top><span style=font-size:16px;font-weight:700>Beløp å betale</span><td style="padding:0 0 5pt"valign=top align=right><span style=font-size:16px;font-weight:700>1000.00</span></table><tr><td style="background:#f7f6ff;padding:15pt .5in"valign=top class=sm_padding_x><table border=0 cellpadding=0 cellspacing=0 style=width:100%;border-collapse:collapse;table-layout:fixed width=100%><tr><td style="padding:8pt 10pt 8pt 0;border-bottom:1px solid #ccc"valign=top><span style=font-weight:700>Fakturanr/delkrav</span><td style="padding:8pt 10pt 8pt 0;border-bottom:1px solid #ccc"valign=top><span style=font-weight:700>Forfall:</span><td style="padding:8pt 0;border-bottom:1px solid #ccc"valign=top align=right><span style=font-weight:700>Beløp</span><tr><td style="padding:8pt 10pt 8pt 0;border-bottom:1px solid #ccc"valign=top>456456456<td style="padding:8pt 10pt 8pt 0;border-bottom:1px solid #ccc"valign=top>08.12.2023<td style="padding:8pt 0;border-bottom:1px solid #ccc"valign=top align=right>1000.00<tr><td style="padding:8pt 10pt 8pt 0"valign=top><span style=font-weight:700>Sum hovedstol:</span><td style="padding:8pt 10pt 8pt 0"valign=top> <td style="padding:8pt 0"valign=top align=right><span style=font-weight:700>1000.00</span></table><tr><td style="background:#ffe5e6;padding:25pt .5in"valign=top class=sm_padding_x align=center><div><p><span style=font-weight:700>Det lønner seg å løse saken</span><p>Det løper fort på ytterligere kostnader for deg i en inkassosak som denne. Vi anbefaler deg derfor å gjøre ditt beste for å løse saken. Betal innen forfall, eller ta kontakt med oss for å se om vi kan komme frem til en nedbetalingsordning eller lignende.</div><tr><td style="background:#dcddff;padding:25pt .5in;text-align:center"valign=top class=sm_padding_x align=center><table border=0 cellpadding=0 cellspacing=0 style="width:75%;border-collapse:collapse;margin:0 auto;table-layout:fixed"class=sm_container><tr><td style=padding:10pt valign=top align=center colspan=2 rowspan=1><p><span style=font-weight:700>Unicorn Collection AS Portal</span><p class=text-truncate><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">DebtorPortalURL</params></table><table border=0 cellpadding=0 cellspacing=0 style="width:75%;border-collapse:collapse;margin:0 auto;table-layout:fixed"class=sm_container><tr><td style="padding:10pt;border-right:1px solid #afafc8"valign=top class="sm_column sm_border_none"align=center><p><span style=font-weight:700>Brukernavn</span><p>DT<params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">CExCaseNo</params><td style=padding:10pt valign=top class=sm_column align=center><p><span style=font-weight:700>Passord</span><p><params contenteditable="false" suppresscontenteditablewarning="true" isrepeating="false">PPassword</params></table></table></table></table></div></table></div></table></div></table></div>',
                isDefault: true,
                repeatingContent: null,
                isRepeating: false,
                repeatingAdapterId: 0,
              },
            ],
          },
        ],
      },
    ],
    rootElement: "html",
    headElement: "",
    backImage: false,
    category: "Documents",
    content: true,
    templateId: 0,
    templateName: "Untitled Template",
    group: "",
    isMarginApplied: false,
    previewImage: null,
    output: {
      format: DocumentType.EMAIL,
    },
    adapter: {
      mainAdapterId: 1,
      repeatingAdapters: [],
    },
    margin: DEFAULT_PAGE_MARGINS,
    versionNo: -1,
  },
};

export const DEFAULT_SECTION_DATA = {
  rules: [],
  pageIndex: -1,
  defaultRule: "",
  selectedRule: "",
  template: "",
  id: "",
  properties: {
    width: 0,
    height: 0,
    x: 0,
    y: 0,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  name: "",
  color: "",
  repeatingAdapterId: 0,
  width: 0,
  height: 0,
  locked: false,
  repeatable: false,
};

export const DocumentTemplates = {
  [DocumentType.ALL]: DEFAULT_TEMPLATE_DETAILS,
  [DocumentType.PDF]: DEFAULT_TEMPLATE_DETAILS,
  [DocumentType.SMS]: DEFAULT_SMS_TEMPLATE_DETAILS,
  [DocumentType.EMAIL]: DEFAULT_EMAIL_TEMPLATE_DETAILS,
  [DocumentType.EHF]: DEFAULT_TEMPLATE_DETAILS,
};
